import { render, staticRenderFns } from "./dict_table.vue?vue&type=template&id=636b57df"
import script from "./dict_table.vue?vue&type=script&lang=js"
export * from "./dict_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports